import { api } from '../client';

export interface UserStatus {
  uuid: string;
  name: string;
}

export interface UserStatusesResponse {
  success: boolean;
  message: string;
  data: {
    user_statuses: UserStatus[];
  };
}

class UserStatusesResourceService {
  async getUserStatuses(): Promise<UserStatusesResponse> {
    const response = await api.get<UserStatusesResponse>('/resource-lists?types=user_statuses');
    return response.data;
  }
}

const userStatusesResourceService = new UserStatusesResourceService();
export default userStatusesResourceService;

